import { X } from "lucide-react";
import React from "react";
import { Button } from "@/components/ui/button";
import { useToast as useToastBase } from "@/components/ui/use-toast";

export const useToastDefault = () => {
  const { toast } = useToastBase();

  const showToast = React.useCallback(
    (title: string, description: string) => {
      const { dismiss } = toast({
        title,
        description,
        duration: 2000,
        action: (
          <Button variant="outline" size="sm" onClick={() => dismiss()}>
            <X className="h-4 w-4" />
          </Button>
        ),
      });
    },
    [toast],
  );

  return { showToast };
};
